import React from 'react';

import { useNFTsPageStore } from '@app/store/zustand';

import CheckIcon from './svg/check.svg?react';
import PlusIcon from './svg/plus.svg?react';

import { Wrapper } from './styles';

interface Props {
    item_id?: string;
    isSelected?: boolean;
}

export const SelectedButton = ({ item_id, isSelected }: Props) => {
    const { handleSelectItem } = useNFTsPageStore();

    if (!item_id) return null;

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();

        handleSelectItem(item_id);
    };

    return (
        <Wrapper
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            onClick={handleClick}
            $isAddedItem={isSelected}
        >
            {isSelected ? <CheckIcon /> : <PlusIcon />}
        </Wrapper>
    );
};
